import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { useAppContext } from 'src/contexts/AppContext';
import { ErrorTypes, useClientLogContext } from 'src/contexts/ClientLogContext';
import { DATA_REFRESH_RATE_IN_MILLIS_LONG } from 'src/utils/constants/constants';
import { PricingClient } from 'src/WebApiController';

export const useEventMapConfigMetadata = (viagogoEventId: number | null) => {
  const { activeAccountWebClientConfig } = useAppContext();
  const { showErrorDialog } = useClientLogContext();

  const shouldQuery = useMemo(
    () =>
      viagogoEventId != null &&
      activeAccountWebClientConfig?.activeAccountId != null,
    [activeAccountWebClientConfig?.activeAccountId, viagogoEventId]
  );

  const eventMapConfigQuery = useQuery({
    queryKey: [
      'PricingClient.GetEventMapConfigMetadata',
      activeAccountWebClientConfig?.activeAccountId,
      viagogoEventId,
    ],
    queryFn: async () => {
      return await new PricingClient(
        activeAccountWebClientConfig
      ).getEventMapConfigMetadata(viagogoEventId!);
    },
    enabled: shouldQuery,
    staleTime: Infinity,
    refetchInterval: DATA_REFRESH_RATE_IN_MILLIS_LONG,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    meta: {
      onError: (error: ErrorTypes) => {
        showErrorDialog('PricingClient.GetEventMapConfigMetadata', error, {
          trackErrorData: {
            viagogoEventId,
          },
        });
      },
    },
  });

  return {
    eventMapConfigQuery,
  };
};
